import React, { useCallback, useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Slider } from "primereact/slider";
import { useFormik } from "formik";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import GoogleMapComp from "./GoogleMapComp";
import "../passenger.css";
import * as Yup from "yup";
import { AutoComplete } from "primereact/autocomplete";
import { useDispatch, useSelector } from "react-redux";
import { handleGetRequest } from "../../../services/GetTemplate";
import { handlePostRequest } from "../../../services/PostTemplate";
import { MultiSelect } from "primereact/multiselect";
import { toast } from "react-toastify";
import Axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const RideBooking = () => {
    const userId = useSelector((state) => state?.authenticationSlice?.userId);
    const userType = localStorage.getItem("selectedUserType");
    const vehicleId = localStorage.getItem("vehicleId");
    const selectedVehicleId = localStorage.getItem("selectedVehicleId");

    const [Place, setPlace] = useState([]);
    const [filteredPlace, setFilteredPlace] = useState(null);
    const [direction, setDirection] = useState(null);
    const [maploaded, setMapLoaded] = useState(false);
    const [startPosition, setStartPosition] = useState(null);
    const [endPosition, setEndPosition] = useState(null);
    const [isRecursive, setIsRecursive] = useState(false);
    const [visible, setVisible] = useState(false);
    const [isActiveNowRide, setIsActiveNowRide] = useState(true);
    const [isRideActive, setIsRideActive] = useState(false);
    const [isUpcomingRide, setIsUpcomingRide] = useState(false);
    const [estimatedFare, setEstimatedFare] = useState(null);
    const [date, setDate] = useState();
    const [fromTime, setFromTime] = useState();
    const [toTime, setToTime] = useState();
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [day, setDay] = useState();
    const [dateValue, setDateValue] = useState(null);
    const [userVehicleList, setUserVehicleList] = useState([]);
    const [polyLine, setPolyLine] = useState([]);
    const [boundSw, setBoundSw] = useState([]);
    const [boundNe, setBoundNe] = useState([]);
    const dispatch = useDispatch();
    const history = useHistory();
    const [kmLeverage, setKmLeverage] = useState(5); // Default value is 5

    const validationSchema = Yup.object().shape({
        startPoint: Yup.mixed().required("This field is required."),
        endPoint: Yup.mixed().required("This field is required."),
        seat: Yup.mixed().required("This field is required."),
        gender: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            startPoint: "",
            endPoint: "",
            seat: "1",
            gender: "Any",
            polyline: "",
            estimatedFare: "",
        },
        onSubmit: async (data) => {
            const distanceText = direction?.routes[0]?.legs[0]?.distance?.value;
            // const numericDistance = distanceText ? String(parseFloat(distanceText.match(/\d+(\.\d+)?/)[0])) : null;

            const duration = direction?.routes[0]?.legs[0]?.duration?.value;

            //For Getting current date and 30mins
            const activeDate = new Date();
            const currentDate = activeDate.toISOString().replace("T", " ").replace("Z", "Z");
            const newDate = new Date(activeDate.getTime() + 30 * 60000); // Adding 30 minutes in milliseconds
            const newDate30mins = newDate.toISOString().replace("T", " ").replace("Z", "Z");

            //For getting current time
            const currentTime = new Date();
            const hours = currentTime.getHours();
            const minutes = currentTime.getMinutes();
            const ampm = hours >= 12 ? "PM" : "AM";

            // Convert 24-hour time to 12-hour time
            const formattedHours = hours % 12 || 12; // Converts 0 to 12 for midnight
            const formattedMinutes = minutes < 10 ? "0" + minutes : minutes; // Adds leading zero to minutes if needed

            const timeString = `${formattedHours}:${formattedMinutes} ${ampm}`;

            const obj = {
                startPoint: startPosition,
                endPoint: endPosition,
                availableSeats: data.seat,
                gender: data.gender,
                polyline: data.polyline,
                isScheduled: false,
                userId: userId,
                vehicleId: userType == "1" ? selectedVehicleId || vehicleId : "",
                // vehicleId:'6780add54f73f9082623f33b',
                bounds_sw: boundSw,
                bounds_ne: boundNe,

                distance: distanceText,
                polyline: polyLine,
                duration: duration,
                activeCorporateCode: false,
                corporateCode: "",
                startTime: isActiveNowRide ? currentDate : fromTime,
                endTime: isActiveNowRide ? newDate30mins : toTime,
                date: isActiveNowRide ? currentDate : date,
                kmLeverage: selectedVehicleId === "1" && kmLeverage,
            };
            //Schedule data
            if (isRecursive) {
                // obj.date = fromDate;
                // obj.startTime = fromDate;
                // obj.endTime = fromDate;
                obj.startDate = fromDate;
                obj.endDate = toDate;
                obj.days = day;
            } else {
                obj.date = isActiveNowRide ? currentDate : date;
            }

            console.log("payload", obj);

            try {
                let response;
                //Driver
                if (userType == 1 && isRecursive === false) {
                    response = await dispatch(handlePostRequest(`api/route`, obj, true, true));
                }
                //Passenger
                else if (userType !== 1 && isRecursive === false) {
                    response = await dispatch(handlePostRequest(`api/scheduleride`, obj, true, true));
                }
                //Driver Recursive
                else if (userType == 1 && isRecursive === true) {
                    response = await dispatch(handlePostRequest(`api/route/recursive`, obj, true, true));
                }
                //Passenger Recursive
                else if (userType !== 1 && isRecursive === true) {
                    response = await dispatch(handlePostRequest(`api/scheduleride/recursive`, obj, true, true));
                }

                console.log(response, "response");
                if (response?.status === 201) {
                    history.push("/schedules");
                }
            } catch (error) {
                console.log("error", error);
                toast.error("Error in submitting the form");
            }
        },
    });

    console.log("isActiveNowRide", isActiveNowRide);
    console.log("isRecursive", isRecursive);
    const handleInputChange = (e) => {
        const value = e?.target?.value;
        if (value === "" || (Number(value) <= 10 && Number(value) > 0)) {
            formik.handleChange(e);
        }
    };

    const genderLov = [
        { name: "Male", value: "male" },
        { name: "Female", value: "female" },
        { name: "Any", value: "any" },
    ];

    const daysLov = [
        { name: "Monday", value: 1 },
        { name: "Tuesday", value: 2 },
        { name: "Wednesday", value: 3 },
        { name: "Thursday", value: 4 },
        { name: "Friday", value: 5 },
        { name: "Saturday", value: 6 },
        { name: "Sunday", value: 7 },
    ];

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const handleSchdeuleRide = () => {
        setVisible(false);
        // setIsRecursive(false);
        // setFromTime("");
        // setToTime("");
        // setDate("");
        // setFromDate("");
        // setToDate("");
        // setDay("");
    };

    const getScheduleRide = () => {
        setIsActiveNowRide(false);
        setVisible(true);
    };

    const getActiveNowRide = () => {
        const date = new Date().toLocaleDateString();
        setDateValue(date);
        setIsActiveNowRide(true);
    };

    const handleCloseDialogBox = () => {
        if (!visible) return;
        setVisible(false);
        setIsActiveNowRide(true);
    };

    const handleMapLoaded = useCallback(() => {
        setMapLoaded(true);
    }, []);

    const search = (event) => {
        setFilteredPlace(Place);
    };

    const getLocationName = async (value) => {
        const response = await dispatch(handleGetRequest(`api/web/googleMap/?text=${value}`, false, false));
        if (response) {
            setPlace(response?.data);
        }
    };

    const handleStartLocation = async (e) => {
        formik.handleChange(e);
        let value = e?.target?.value;
        getLocationName(value);
    };
    const handleEndLocation = async (e) => {
        formik.handleChange(e);
        let value = e?.target?.value;
        getLocationName(value);
    };

    const submitLocation = () => {
        let pickUpLocation = formik?.values?.startPoint;
        let dropOffLocation = formik?.values.endPoint;
        if (pickUpLocation && dropOffLocation) {
            if (window.google && window.google.maps && maploaded) {
                const directionService = new window.google.maps.DirectionsService();
                const request = {
                    origin: pickUpLocation,
                    destination: dropOffLocation,
                    travelMode: window.google.maps.TravelMode.DRIVING,
                };
                directionService.route(request, (result, status) => {
                    if (status === window.google.maps.DirectionsStatus.OK) {
                        setDirection(result);
                        console.log(result, "result");
                        getEstimatedFare();
                    } else {
                        alert("Could not calculate directions: " + status);
                    }
                });
            }
        }
    };

    const getEstimatedFare = async () => {
        console.log(direction?.routes[0]?.legs[0]?.distance);
        if (direction) {
            let distance = direction?.routes[0]?.legs[0]?.distance?.value;
            setPolyLine(direction?.routes[0]?.overview_polyline);
            const response = await dispatch(handleGetRequest(`api/scheduleride/estimatedFare?distance=${distance}&corporateCode=${null}`, false, false));
            if (response?.data) {
                setEstimatedFare(response?.data?.estimatedFare);
            }
        }
    };

    useEffect(() => {
        if (formik?.values.startPoint && formik?.values.endPoint) {
            getEstimatedFare();
        }
    }, [formik.values.startPoint, formik.values.endPoint, direction]);

    useEffect(() => {
        formik.setFieldValue("gender", "any");
    }, []);

    useEffect(() => {
        const getCurrentLocation = async () => {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    const addressName = await fetchAddress(latitude, longitude);
                    formik.setFieldValue("startPoint", addressName?.address);
                },
                (error) => {
                    // console.error('Error getting location:', error);
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0,
                }
            );
        };

        getCurrentLocation();
    }, []);

    const fetchAddress = async (lat, lng) => {
        try {
            const response = await Axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyAnbMv1DS7NNcrx-DaSX9MlfPtZFy68ELU`);
            if (response?.data.status === "OK") {
                const location = {
                    placeName: response?.data.results[0].formatted_address,
                    latitude: response?.data.results[0].geometry.location.lat,
                    longitude: response?.data.results[0].geometry.location.lng,
                };
                return location;
            } else {
                console.warn("No results found");
            }
        } catch (error) {
            // console.log(error)
        }
    };

    // Handle Start Marker Drag End
    const handleStartMarkerDragEnd = async (event, position) => {
        const newLat = event?.latLng?.lat();
        const newLng = event?.latLng?.lng();
        console.log("New marker position:", { lat: newLat, lng: newLng });

        if (newLat && newLng) {
            const { address } = await fetchAddress(newLat, newLng);
            setStartPosition(address);
            formik.setFieldValue("startPoint", address?.address);
        }
    };
    // Handle End Marker Drag End
    const handleEndMarkerDragEnd = async (event) => {
        const newLat = event.latLng.lat();
        const newLng = event.latLng.lng();

        if (newLat && newLng) {
            const { address } = await fetchAddress(newLat, newLng);
            setStartPosition(address);
        }
    };

    const getLatLngFromAddress = async (address) => {
        const API_KEY = "AIzaSyAnbMv1DS7NNcrx-DaSX9MlfPtZFy68ELU"; // Replace with your API key
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${API_KEY}`;

        try {
            const response = await Axios.get(url);
            if (response.data.status == "OK") {
                const result = response.data.results[0];
                console.log("result:", result);
                const bounds = result.geometry.bounds;
                const bounds_sw = bounds?.southwest ? [bounds.southwest.lat, bounds.southwest.lng] : null;
                const bounds_ne = bounds?.northeast ? [bounds.northeast.lat, bounds.northeast.lng] : null;
                setBoundSw(bounds_sw);
                setBoundNe(bounds_ne);
                console.log("Bounds:", bounds_sw, bounds_ne);

                const location = response.data.results[0]?.geometry?.location;
                return location;
            } else {
                console.error("Geocoding failed:", response.data.status);
                return null;
            }
        } catch (error) {
            console.error("Error fetching geocoding data:", error);
            return null;
        }
    };

    const fetchCoordinates = async () => {
        const address = formik?.values?.startPoint;
        if (address) {
            const coordinates = await getLatLngFromAddress(formik?.values?.startPoint);
            if (coordinates) {
                setStartPosition({
                    placeName: address,
                    latitude: coordinates.lat,
                    longitude: coordinates.lng,
                });
            }
        }
    };

    const fetchCoordinatesendpoint = async () => {
        const address = formik?.values?.endPoint;
        if (address) {
            const coordinates = await getLatLngFromAddress(formik?.values?.endPoint);
            if (coordinates) {
                setEndPosition({
                    placeName: address,
                    latitude: coordinates.lat,
                    longitude: coordinates.lng,
                });
            } else {
                console.log("error accoured");
            }
        }
    };

    useEffect(() => {
        if (formik?.values?.startPoint || formik?.values?.endPoint) {
            fetchCoordinates();
            fetchCoordinatesendpoint();
        }
    }, [formik?.values?.startPoint, formik?.values?.endPoint]);

    const handleIncrease = () => {
        if (kmLeverage < 5) {
            setKmLeverage(kmLeverage + 1);
        }
    };
    const handleDecrease = () => {
        if (kmLeverage > 1) {
            setKmLeverage(kmLeverage - 1);
        }
    };
    return (
        <div>
            {/* {window.innerWidth >= 991 ? ( */}
            <>
                <div className="grid mx-0 w-full" style={{ gap: "2rem" }}>
                    {isRideActive && (
                        <div className="surface-card col-12 lg:col-4 p-3 mb-3 h-full">
                            <h6 className="font-semibold mb-1">Active Ride</h6>
                            <div className="  flex p-2">
                                <div className="flex align-items-center flex-column mr-2 my-1">
                                    <i className="block text-lg pi pi-circle"></i>
                                    <span className="map-border-line"></span>
                                    <i className="block text-lg pi pi-map-marker"></i>
                                </div>
                                <div>
                                    <p className="mb-3 ml-2 font-semibold text-md">Gulberg green</p>
                                    <p className="mb-0 ml-2 font-semibold text-md">G10 Markaz</p>
                                </div>
                            </div>
                        </div>
                    )}
                    {isUpcomingRide && (
                        <div className="surface-card col-12 lg:col-4 p-3 mb-3 h-full">
                            <h6 className="font-semibold mb-1">Upcoming Ride</h6>
                            <div className="  flex p-2">
                                <div className="flex align-items-center flex-column mr-2 my-1">
                                    <i className="block text-lg pi pi-circle"></i>
                                    <span className="map-border-line"></span>
                                    <i className="block text-lg pi pi-map-marker"></i>
                                </div>
                                <div>
                                    <p className="mb-3 ml-2 font-semibold text-md">Gulberg green</p>
                                    <p className="mb-0 ml-2 font-semibold text-md">G10 Markaz</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="lg:flex justify-content-between ">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="surface-card p-5 riding-booking-card ">
                            <h4 className="text-white mb-5 font-semibold">Ride Booking</h4>
                            {/* <div className='flex align-items-center'> */}

                            <div className=" grid justify-content-center align-items-end ">
                                <div className="col-12 mb-2">
                                    <label className="block mb-2 text-white font-semibold ">Starting Point</label>
                                    <div className="p-inputgroup">
                                        {/* <span className="p-inputgroup-addon">
                                                <i className="pi pi-circle "></i>
                                            </span> */}
                                        <AutoComplete id="startPoint" value={formik?.values?.startPoint} suggestions={filteredPlace} completeMethod={search} onChange={handleStartLocation} name="startPoint" placeholder="Pick Up Location" className="w-full" onHide={submitLocation} />
                                        <span className="p-inputgroup-addon">
                                            {" "}
                                            <i className="pi pi-map-marker "></i>
                                        </span>
                                    </div>
                                    {getFormErrorMessage("startPoint")}
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="block mb-2 text-white font-semibold">Destination</label>
                                    <div className="p-inputgroup">
                                        {/* <span className="p-inputgroup-addon">
                                                <i className="pi pi-stop-circle "></i>
                                            </span> */}
                                        <AutoComplete id="endPoint" type="text" value={formik?.values?.endPoint} suggestions={filteredPlace} completeMethod={search} onChange={handleEndLocation} name="endPoint" placeholder="Drop Off Location" className="w-full " onHide={submitLocation} />
                                        {/* <AutoComplete id="endPoint" value={formik?.values?.endPoint} suggestions={filteredPlace} completeMethod={search} name="endPoint" placeholder="Drop Off Location" className="w-full" /> */}
                                        <span className="p-inputgroup-addon">
                                            <i className="pi pi-map-marker"></i>
                                        </span>
                                    </div>
                                    {getFormErrorMessage("endPoint")}
                                </div>
                            </div>
                            {/* </div> */}

                            <div className="grid  align-items-start">
                                <div className="col-6 mb-3">
                                    <label className="text-white font-semibold mb-3">Seats</label>
                                    <InputText name="seat" id="seat" value={formik?.values?.seat} onChange={handleInputChange} className="w-full mt-2 " />
                                    {getFormErrorMessage("seat")}
                                </div>
                                <div className="col-6 mb-3">
                                    <label className="text-white font-semibold mb-3">Travel With</label>
                                    <Dropdown id="gender" name="gender" value={formik?.values?.gender} placeholder="Select Gender" options={genderLov} optionLabel="name" optionValue="value" onChange={formik.handleChange} className="w-full mt-2 " />
                                    {getFormErrorMessage("gender")}
                                </div>
                                <div className="col-12 mb-3">
                                    <div className="flex justify-content-between align-items-center">
                                        <label className="text-white font-semibold ">Schedule time</label>
                                        <div className="">
                                            <Button label={`${isActiveNowRide ? "Now" : "Schedule"}`} className="text-base p-2 mr-1 outline" type="button" onClick={getActiveNowRide} />
                                            <Button icon="pi pi-history" className="text-base p-2 ml-1 outline " type="button" onClick={getScheduleRide} />

                                            <Dialog className="surface-card dialog-card" header="Schedule Ride" visible={visible} onHide={handleCloseDialogBox}>
                                                <div className="flex align-items-center mb-4">
                                                    <label id="checkbox" className="mr-2">
                                                        Is Recursive
                                                    </label>
                                                    <Checkbox id="checkbox" onChange={(e) => setIsRecursive(e.checked)} checked={isRecursive}></Checkbox>
                                                </div>
                                                {isRecursive ? (
                                                    <>
                                                        <div className="grid mb-3">
                                                            <div className="col-12">
                                                                <label id="fromDate" name="fromDate" className="text-white font-semibold">
                                                                    From Date
                                                                </label>
                                                                <Calendar id="fromDate" name="fromDate" showIcon showTime showSeconds value={fromDate} placeholder="From Date " onChange={(e) => setFromDate(e.target.value)} className="input-calendar w-full mt-2" />
                                                            </div>
                                                            <div className="col-12">
                                                                <label id="toDate" name="toDate" className="text-white font-semibold">
                                                                    To Date
                                                                </label>
                                                                <Calendar id="toDate" name="toDate" showIcon showTime showSeconds value={toDate} placeholder="To Date" onChange={(e) => setToDate(e.target.value)} className="input-calendar w-full mt-2" />
                                                            </div>
                                                            <div className="col-12">
                                                                <label id="day" name="day" className="text-white font-semibold">
                                                                    Days
                                                                </label>
                                                                <MultiSelect id="day" name="day" value={day} onChange={(e) => setDay(e.value)} options={daysLov} optionLabel="name" display="chip" placeholder="Select Days" className="w-full mt-2 p-1" />
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="grid mb-3">
                                                            <div className="col-12 mb-4">
                                                                <label id="date" name="date" className="text-white font-semibold">
                                                                    Date
                                                                </label>
                                                                <Calendar id="date" name="date" showIcon value={date} onChange={(e) => setDate(e.target.value)} placeholder="Enter Date" className="input-calendar w-full mt-2" />
                                                            </div>
                                                            <label className="col-12 py-0 text-white font-semibold">Search ride in between</label>
                                                            <div className="col-6 py-0">
                                                                <Calendar id="fromTime" name="fromTime" showIcon value={fromTime} placeholder="From Time" onChange={(e) => setFromTime(e.target.value)} timeOnly icon={() => <i className="pi pi-clock" />} className="input-calendar w-full mt-2" />
                                                            </div>
                                                            <div className="col-6 py-0">
                                                                <Calendar id="toTime" name="toTime" showIcon value={toTime} placeholder="To Time" onChange={(e) => setToTime(e.target.value)} timeOnly icon={() => <i className="pi pi-clock" />} className="input-calendar w-full mt-2" />
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                <Button className="block mx-auto mt-5" type="button" label="Schedule" onClick={handleSchdeuleRide}></Button>
                                            </Dialog>
                                        </div>
                                    </div>
                                </div>
                                {userType === "1" && (
                                    <div className="px-3">
                                        <p>How for you are willing to deviate from your route?</p>
                                        <div className="butons" style={{ display: "flex", alignItems: "flex-start", justifyContent: "center", gap: "10px" }}>
                                            <Button style={{ height: "30px" }} onClick={handleDecrease}>
                                                -
                                            </Button>
                                            <h4 style={{ height: "20px", margin: "0px" }}>{kmLeverage} km</h4>
                                            <Button style={{ height: "30px" }} onClick={handleIncrease}>
                                                +
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {estimatedFare && (
                                <div className="text-center mt-2">
                                    <span className="text-white">Estimated Fare </span>
                                    <h3 className="mt-2 font-semibold text-white">Rs {estimatedFare}</h3>
                                </div>
                            )}
                            <Button label="Submit" type="submit" className="block mx-auto px-5 mt-5" />
                        </div>
                    </form>

                    <div className={`google-map-card`}>
                        <GoogleMapComp directions={direction} mapLoading={handleMapLoaded} />
                    </div>
                </div>
            </>
        </div>
    );
};

export default RideBooking;
